module.exports = (__webpack_require__(4))(324);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/symbol-observable/index.js from dll-reference carbon.vendor
// module id = 16
// module chunks = 0